<template>
  <div ref="component" class="cubeSpace">
    <section class="ancho grid-efi">
      
      <aside>
        <h1 class="fuente-posm">Mejoramos la experiencia de tus clientes.</h1>
        <button class="button-outline font- hover-boton_mod fuente-nova2" @click="openContactModal">
          Descubre Como
        </button>
      </aside>

      <aside class="aside-figure">
        <figure>
          <img :src="a91" class="img-fluid w-100">
        </figure>
        <p class="fuente-posm">Sorprende a tus clientes.</p>
      </aside>

      <!-- Carrusel Social Proof -->
      <section class="social-proof">
        <transition name="fade" mode="out-in">
          <div class="social-proof__item" :key="currentIndex">
            <aside>
              <figure>
                <img :src="partners[currentIndex].logo" :alt="partners[currentIndex].name">
              </figure>
            </aside>

            <div class="linea-divisor"></div>

            <aside>
              <p>{{ partners[currentIndex].description }}</p>
            </aside>
          </div>
        </transition>
      </section>

    </section>
  </div>
  
  <ContactModal />
</template>

<script>
import ContactModal from '@/components/modal/Contact.vue'

export default {
  components: { ContactModal },
  name: "page1",
  emits: ["sendAction"],
  
  props: {
    action: {
      type: Object,
      default: () => {},
    },
    pos: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      a91: require("@/assets/images/a91.webp"),
      currentIndex: 0,
      intervalId: null,
      
      partners: [
        {
          name: 'Oracle',
          logo: require('@/assets/images/oracle.png'),
          description: 'Efisense es Partner Certificado, con lo cual respaldamos la seguridad de tus operaciones.'
        },
        {
          name: 'Bostons',
          logo: require('@/assets/images/bostons.png'),
          description: 'Implementación exitosa en la mayoría de sus sucursales a nivel nacional, consolidando operaciones.'
        },
        {
          name: 'Soft',
          logo: require('@/assets/images/soft.png'),
          description: 'Implementación exitosa en múltiples sucursales, optimizando la gestión operativa.'
        },
        {
          name: 'SushiRoll',
          logo: require('@/assets/images/sushiroll.png'),
          description: 'Mejoró significativamente la experiencia de espera de sus comensales implementando Flow'
        },
        {
          name: 'Mb Chicken',
          logo: require('@/assets/images/mb.png'),
          description: 'Franquicia canadiense que mide la satisfacción del cliente con encuestas automáticas en todas sus sucursales en México.'
        },
        {
          name: 'Rappi',
          logo: require('@/assets/images/rappi.png'),
          description: 'Integramos con el equipo de Rappi, automatizando el ingreso de sus pedidos de forma automática, reduciendo tiempos de espera.'
        },
        {
          name: 'Adyen',
          logo: require('@/assets/images/adyen.png'),
          description: 'Integración pionera con su terminal de pagos en México, ofreciendo procesamiento avanzado y confiable'
        },
        {
          name: 'Uber',
          logo: require('@/assets/images/uber.png'),
          description: 'Partnership tecnológico que permite el desarrollo de soluciones avanzadas para restaurantes'
        },
        {
          name: 'Parroquia',
          logo: require('@/assets/images/parroquia.png'),
          description: 'Digitalización completa de su sistema de facturación, adaptado a las necesidades organizacionales específicas.'
        },
        {
          name: 'Xenial',
          logo: require('@/assets/images/xenial.png'),
          description: 'Compatibilidad nativa con su plataforma POS, asegurando operación continua sin interrupciones técnicas.'
        },
        {
          name: 'Videre',
          logo: require('@/assets/images/videre.png'),
          description: 'Clínica oftalmológica que redujo 20% sus ausencias de pacientes optimizando la gestión de citas'
        },
        {
          name: 'Givex',
          logo: require('@/assets/images/givex.png'),
          description: 'Conectividad directa con su sistema de pagos, facilitando el flujo unificado de información.'
        },
        {
          name: 'Izakaya',
          logo: require('@/assets/images/izakaya.png'),
          description: 'Mejoró la experiencia de espera de sus clientes con Flow, incrementando la satisfacción general.'
        },
        {
          name: 'Positouch',
          logo: require('@/assets/images/positouch.png'),
          description: 'Compatibilidad total con su POS, garantizando una integración sin complicaciones.'
        },
      ],
    };
  },

  watch: {
    action: {
      handler() {
        this.getAction();
      },
      deep: true,
    },
  },

  mounted() {
    this.getComponentHeight();
    this.startCarousel();
  },

  beforeUnmount() {
    this.stopCarousel();
  },

  methods: {
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, 4000);
    },

    stopCarousel() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.partners.length;
    },

    openContactModal() {
      const modalEl = document.getElementById('contactModal');
      if (modalEl) {
        import('bootstrap').then(({ Modal }) => {
          const contactModal = new Modal(modalEl);
          contactModal.show();
        });
      }
    },

    getComponentHeight() {
      let component = this.$refs.component;
      this.$emit("sendAction", {
        action: "setHeight",
        data: { pos: this.pos, val: component.offsetHeight },
      });
    },

    getAction() {
      switch (this.action?.type) {
        case "?":
          break;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.cubeSpace {
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-efi {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  place-items: center;
  place-content: center;
  width: 100%;
  max-width: 1800px;
}

.grid-efi aside {
  max-width: 800px;
  height: auto;
  margin: 15px;
}

.grid-efi h1 {
  font-size: clamp(30px, 4vw, 65px);
  line-height: 1.1;
  color: var(--color-2);
  margin-bottom: 30px;
}

.grid-efi aside figure {
  max-width: 800px;
  height: auto;
  margin: 0;
}

.grid-efi aside figure img {
  width: 100%;
}

.aside-figure {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  text-align: center;
}

.aside-figure p {
  font-size: clamp(16px, 2vw, 35px);
  margin-top: 20px;
  color: var(--color-2);
}

/* ========== Social Proof Carrusel ========== */
.social-proof {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 800px;
  margin-top: 90px;
}

.social-proof__item {
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-proof aside figure {
  width: 150px;
  height: auto;
  margin: 0;
}

.social-proof aside figure img {
  margin: 0;
  max-width: 100%;
}

.social-proof aside p {
  font-size: clamp(10px, 1vw, 16px);
  margin: 0;
}

.linea-divisor {
  height: 70px;
  width: 5px;
  background-color: #DBDBDB;
  margin: 0px 20px;
}

/* ========== Transiciones ========== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ========== Responsive ========== */
@media screen and (max-width: 1280px) {
  .grid-efi {
    margin-top: 70px;
  }

  .social-proof {
    margin-top: 0px;
  }
}

@media screen and (max-width: 490px) {
  .grid-efi {
    grid-template-columns: 1fr;
    text-align: center;
    margin-top: -130px;
  }

  .social-proof aside figure {
    width: 100px;
  }

  .linea-divisor {
    height: 50px;
    width: 5px;
    background-color: #DBDBDB;
    margin: 0px 10px;
  }

  .aside-figure {
    width: 65%;
  }
}
</style>